import React from 'react';

function getEtapasAbertura(etapas) {
  if (Array.isArray(etapas)) {
    return etapas;
  }

  const etapasAbertura =
    etapas?.EtapasAbeturas ??
    etapas?.EtapasAbetura ??
    etapas?.etapasAbetura ??
    etapas?.etapasAbertura;

  return Array.isArray(etapasAbertura) ? etapasAbertura : [];
}

function TableData({ etapas }) {
  const etapasAbertura = getEtapasAbertura(etapas);

  if (etapasAbertura.length === 0) {
    return <p>Não iniciado</p>;
  }

  return (
    <>
      {etapasAbertura.map((etapa, index) => {
        switch (true) {
          case etapa.mapeamento_status !== 'CONCLUIDO':
            return <p key={index}>Mapeamento</p>;
          case etapa.minuta_status !== 'CONCLUIDO':
            return <p key={index}>Elaboração Minuta Contratual</p>;
          case etapa.viabilidade_status !== 'CONCLUIDO':
            return <p key={index}>Viabilidade</p>;
          case etapa.dbe_status !== 'CONCLUIDO':
            return <p key={index}>DBE</p>;
          case etapa.certificado_status !== 'CONCLUIDO':
            return <p key={index}>Certificado Bird ID</p>;
          case etapa.registro_status !== 'CONCLUIDO':
            return <p key={index}>Registro</p>;
          case etapa.inscricao_municipal_status !== 'CONCLUIDO':
            return <p key={index}>Inscrição Municipal</p>;
          case etapa.deferimento_simples_status !== 'CONCLUIDO':
            return <p key={index}>Deferimento Simples Nacional</p>;
          case etapa.licenciamento_status !== 'CONCLUIDO':
            return <p key={index}>Licenciamento</p>;
          case etapa.mapeamento_status &&
            etapa.minuta_status &&
            etapa.viabilidade_status &&
            etapa.dbe_status &&
            etapa.certificado_status &&
            etapa.registro_status &&
            etapa.inscricao_municipal_status &&
            etapa.deferimento_simples_status &&
            etapa.licenciamento_status === 'CONCLUIDO':
            return <p key={index}>Concluído</p>;
          default:
            return <p key={index}>Não iniciado</p>;
        }
      })}
    </>
  );
}

export default TableData;
